import { useState } from 'react';

// Custom hook pro filtrování produktů dle chuti
export const useFilter = (products) => {
    const [activeFilters, setActiveFilters] = useState([]);

    const getOptionCount = (optionId) => {
        const hasProducts = products && products.length > 0;

        return hasProducts ? products.filter((product) => product.flavours.includes(optionId)).length : 0;
    };

    const toggleFilter = (id) => {
        setActiveFilters((prevActiveFilters) => {
            const isFilterActive = prevActiveFilters.includes(id);

            return isFilterActive
                ? prevActiveFilters.filter((prevActiveFilter) => prevActiveFilter !== id)
                : [...prevActiveFilters, id];
        });
    };

    return { activeFilters, toggleFilter, getOptionCount };
};
